import { render, staticRenderFns } from "./RoleRouterLink.vue?vue&type=template&id=78b11c5e&"
import script from "./RoleRouterLink.vue?vue&type=script&lang=js&"
export * from "./RoleRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports